import React from "react";
import { CustomCardProps } from "../../service/interfaces/Components";

const CustomCard: React.FC<CustomCardProps> = ({
  children,
  isActive,
  onClick,
  style,
  className = "", // Default value for className is an empty string
}) => {
  return (
    <div
      className={`max-w-[500px] mx-auto p-4 !shadow-[1px -1px 3.6px 2px #00000033]  transition-all cursor-pointer ${
        isActive ? "bg-[#444FBD] text-white" : "bg-white text-black"
      } ${className}`}
      onClick={onClick}
      style={style}

    >
      {children}
    </div>
  );
};

export default CustomCard;
